/* eslint-disable */
export default {
  mute: 'Mute',
  unmute: 'Unmute',
  hangup: 'Hang up',
  reject: 'Reject',
  hold: 'Hold',
  onHold: 'On Hold',
  transfer: 'Transfer',
  more: 'More',
  stopRecord: 'Stop Recording',
  record: 'Record',
  showKeypad: 'Keypad',
  hideKeypad: 'Hide Keypad',
  unHold: 'Unhold',
  forward: 'Forward',
  ignore: 'Ignore',
  voicemail: 'To voicemail',
  custom: 'Custom',
  answerAndEnd: 'Answer & End',
  answerAndHold: 'Answer & Hold',
  answer: 'Answer',
  completeTransfer: 'Complete transfer',
  reply: 'Reply',
  add: 'Add',
  mergeCall: 'Merge with active call',
  endCallForEveryone: 'End call for everyone',
  leaveCall: 'Leave call',
  leaveOrEndCall: 'Leave or end call?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
